import { t } from 'i18next';
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import i18n from '../i18';

export const Services = () => {
    const language = i18n.language;

    return (
        <section className="px-6 md:px-20 py-20 bg-gray-50">
            
            {/* Section Header */}
            <div className="text-center mb-16">
                <h2 className="text-4xl md:text-5xl font-bold text-[#1a0080] drop-shadow-sm">
                    {t('service.heading1')}
                </h2>
                <p className="text-gray-600 text-[16px] md:text-[20px] max-w-2xl mx-auto mt-4 leading-relaxed">
                    {t('service.heading2')}
                </p>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

                {/* --- SERVICE CARD 1 --- */}
                <div
                    data-aos="fade-up"
                    className="relative group bg-white rounded-2xl shadow-lg p-8 border border-gray-200 hover:shadow-xl transition-all duration-500"
                >
                    {/* Icon */}
                    <div className="absolute -top-5 left-5 bg-[#1a0080] text-white p-3 rounded-xl shadow-lg group-hover:bg-indigo-700 transition-all duration-300">
                        <FaCheck size={20} />
                    </div>

                    {/* Content */}
                    <div className={`ml-12 ${language === 'ar' || language === 'kr' ? 'text-right' : 'text-left'}`}>
                        <p className="text-gray-700 text-[15px] md:text-lg leading-relaxed">
                            {t('service.title1')}
                        </p>
                    </div>

                    {/* Decorative underline */}
                    <div className="w-16 h-[3px] bg-[#1a0080] mt-6 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>

                {/* --- SERVICE CARD 2 --- */}
                <div
                    data-aos="fade-up"
                    data-aos-delay="100"
                    className="relative group bg-white rounded-2xl shadow-lg p-8 border border-gray-200 hover:shadow-xl transition-all duration-500"
                >
                    <div className="absolute -top-5 left-5 bg-[#1a0080] text-white p-3 rounded-xl shadow-lg group-hover:bg-indigo-700 transition-all duration-300">
                        <FaCheck size={20} />
                    </div>

                    <div className={`ml-12 ${language === 'ar' || language === 'kr' ? 'text-right' : 'text-left'}`}>
                        <p className="text-gray-700 text-[15px] md:text-lg leading-relaxed">
                            {t('service.title2')}
                        </p>
                    </div>

                    <div className="w-16 h-[3px] bg-[#1a0080] mt-6 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>

            </div>
        </section>
    );
};
